import React from "react";
import { BackgroundColor } from "@silversea-ssc/ui-components-react";

import { LinkPictureCardProps } from "components/Card/LinkPictureCard";
import LinkCard from "./LinkCard";
import { cruisesLabel } from "src/utils/cruise";
import * as styles from "./DestinationCard.module.scss";

interface DestinationCardProps {
  title: string;
  description?: string;
  cruiseCount?: number;
  image?: LinkPictureCardProps["image"];
  destinationWebCode?: string;
  url?: string;
  background?: BackgroundColor;
  trackingName?: string;
}

const DestinationCard: React.FC<
  React.PropsWithChildren<DestinationCardProps>
> = ({
  destinationWebCode,
  background,
  description,
  cruiseCount,
  trackingName,
  url,
  ...props
}) => {
  const descriptionComponent = (
    <div className={styles.contentWithCount}>
      {description}{" "}
      <div className={styles.cruiseCount}>{cruisesLabel(cruiseCount || 0)}</div>
    </div>
  );
  return (
    <LinkCard
      backgroundColor={background}
      description={descriptionComponent}
      trackingName={trackingName}
      action={{ href: url }}
      {...props}
    />
  );
};

export default DestinationCard;
